(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("nioui", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["nioui"] = factory(require("vue"));
	else
		root["nioui"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_49__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition